import React, { useEffect, useState } from 'react';
import displacementData from '../../../data/displacement_orders.json';

interface DisplacementOrder {
  id: number;
  date: string;
  displacement_blocks: string;
  area_sq_km_displacement: string;
}

const DisplacementLayer: React.FC = () => {
  const [activeOrders, setActiveOrders] = useState<DisplacementOrder[]>([]);

  useEffect(() => {
    // Process and filter recent displacement orders
    const recentOrders = displacementData
      .filter((order: any) => order.area_sq_km_displacement !== "0.00")
      .slice(0, 5); // Show last 5 orders with actual displacement
    setActiveOrders(recentOrders);
  }, []);

  return (
    <>
      {activeOrders.map((order) => (
        <React.Fragment key={order.id}>
          {/* This would render actual block polygons if we had the coordinate data */}
          {/* For now, we'll create a placeholder visualization */}
        </React.Fragment>
      ))}
    </>
  );
};

export default DisplacementLayer;